// HealthSherpa quote deep-link helper.
//
// Generates a URL that opens HealthSherpa's quoting tool in a new tab
// with as much of the client's profile prefilled as possible. No paid
// API — we just construct the well-known query-string contract.
//
// HealthSherpa accepts: zip_code, household_size, age (head of
// household), income, plan_year. They IGNORE unknown params, so we
// always pass the broadest set we have.
//
// Usage:
//   import { healthSherpaQuoteUrl } from '../lib/healthSherpaLink';
//   const url = healthSherpaQuoteUrl({ zip: '78704', household_size: 3,
//                                       age: 42, income: 55000 });
//   window.open(url, '_blank', 'noopener,noreferrer');

const BASE_URL = 'https://www.healthsherpa.com/marketplace/health';

export function healthSherpaQuoteUrl({
  zip,
  household_size,
  age,
  income,
  plan_year,
  tobacco,
  agent_npn,
}) {
  const p = new URLSearchParams();
  if (zip)             p.set('zip_code',       String(zip).slice(0, 5));
  if (household_size)  p.set('household_size', String(Math.max(1, Number(household_size) || 1)));
  if (age)             p.set('age',            String(age));
  if (income)          p.set('income',         String(Math.max(0, Number(income) || 0)));
  if (plan_year)       p.set('plan_year',      String(plan_year));
  if (tobacco)         p.set('tobacco',        tobacco === 'none' ? 'false' : 'true');
  // If the operator has an agent NPN on file, HealthSherpa will
  // attribute the quote to them (commission attribution).
  if (agent_npn)       p.set('agent_npn',      String(agent_npn));
  const qs = p.toString();
  return qs ? `${BASE_URL}?${qs}` : BASE_URL;
}

// Same shape for the UHOne quoter. UHOne uses a simpler prefilled
// landing — most info is collected on-page, but ZIP is the gate.
export function uhOneQuoteUrl({ zip }) {
  const z = String(zip || '').slice(0, 5);
  return z ? `https://www.uhone.com/health-insurance-plans-rates?zip=${z}` : 'https://www.uhone.com';
}
